import React from 'react';

import './App.css';
import Header from './components/Header/Header';
import Sho from './components/Shop/Sho'
  




function App() {
  return (
    <div>
      <Header> </Header>
      <Sho> </Sho>
    
    </div>
  );
}

export default App;
